import { connect } from 'react-redux';
import NotAuthenticated from './not-authenticated';

function mapStateToProps (state) {
  return {
    user: state.user
  };
};

export default connect(mapStateToProps)(NotAuthenticated);



/** WEBPACK FOOTER **
 ** ./src/interactive-solutions/authentication/components/not-authenticated-container.js
 **/